export default function() {
    this.eventSource.close()
    this.$root.$emit('messagesClosed')
}
